/**
 * The ID token this page's last sign-in returned, kept in memory only (never storage) so the
 * company step can use it when Identity Platform's `currentUser` has gone missing since. A token is
 * offered only while it has more than a minute left; the API checks it again either way.
 */
let held: string | null = null;

/** Keeps the token (or forgets it, with null) and hands it back. */
export function holdToken<T extends string | null>(token: T): T {
  held = token;
  return token;
}

/** The kept token while it is still valid, else null. */
export function heldToken(now: number = Date.now()): string | null {
  if (!held) return null;
  const expires = expiryOf(held);
  return expires !== null && expires - 60_000 > now ? held : null;
}

/** The token's `exp` in milliseconds, or null when it cannot be read. */
function expiryOf(token: string): number | null {
  const payload = token.split('.')[1];
  if (!payload) return null;
  try {
    const json: unknown = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    const exp = typeof json === 'object' && json !== null && 'exp' in json ? json.exp : null;
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}
